var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#_\xE5\xE7\xFB\xEC\xDF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_3);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xE5\\xE7\\xFB\\xEC\\xDF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_3",
    "data-name": "\\xE5\\xE7\\xFB\\xEC\\xDF\\xED\\xED\\xFB\\xE9 \\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2 3",
    x1: 5.13,
    y1: 29.87,
    x2: 29.87,
    y2: 5.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f44336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9c27b0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.89,29.16h-8.79c-.98,0-1.93-.19-2.83-.57-.87-.37-1.64-.89-2.31-1.56s-1.19-1.44-1.56-2.31c-.38-.9-.57-1.85-.57-2.83v-8.79c0-.98.19-1.93.57-2.83.37-.87.89-1.64,1.56-2.31s1.44-1.19,2.31-1.56c.9-.38,1.85-.57,2.83-.57h8.79c.98,0,1.93.19,2.83.57.87.37,1.64.89,2.31,1.56.67.67,1.19,1.44,1.56,2.31.38.9.57,1.85.57,2.83v8.79c0,.98-.19,1.93-.57,2.83-.37.87-.89,1.64-1.56,2.31-.67.67-1.44,1.19-2.31,1.56-.9.38-1.85.57-2.83.57ZM13.11,8.07c-1.35,0-2.61.52-3.56,1.48-.95.95-1.48,2.22-1.48,3.56v8.79c0,1.35.52,2.61,1.48,3.56.95.95,2.22,1.48,3.56,1.48h8.79c1.35,0,2.61-.52,3.56-1.48.95-.95,1.48-2.22,1.48-3.56v-8.79c0-1.35-.52-2.61-1.48-3.56-.95-.95-2.22-1.48-3.56-1.48h-8.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.5,23.35c-.79,0-1.56-.15-2.28-.46-.7-.29-1.32-.72-1.86-1.25-.54-.54-.96-1.16-1.25-1.86-.31-.72-.46-1.49-.46-2.28s.15-1.56.46-2.28c.29-.7.72-1.32,1.25-1.86.54-.54,1.16-.96,1.86-1.25.72-.31,1.49-.46,2.28-.46s1.56.15,2.28.46c.7.29,1.32.72,1.86,1.25.54.54.96,1.16,1.25,1.86.31.72.46,1.49.46,2.28s-.15,1.56-.46,2.28c-.29.7-.72,1.32-1.25,1.86-.54.54-1.16.96-1.86,1.25-.72.31-1.49.46-2.28.46ZM17.5,13.87c-.97,0-1.88.38-2.57,1.06-.69.69-1.06,1.6-1.06,2.57s.38,1.88,1.06,2.57c.69.69,1.6,1.06,2.57,1.06s1.88-.38,2.57-1.06c.69-.69,1.06-1.6,1.06-2.57s-.38-1.88-1.06-2.57c-.69-.69-1.6-1.06-2.57-1.06Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 23.44,
    cy: 11.3,
    r: 1.36
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.45a06e386bf039c4bd4362dcf95f4577.svg";
export { ForwardRef as ReactComponent };